import {
	faBuilding,
	faComments,
	faEnvelope,
	faMapPin,
	faPhone,
	faUser,
} from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { faCircleCheck } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { validFirstName, validLastName } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm.fn";
import { useSmallCalculator } from "@component/assets/SmallCalculator/SmallCalculatorContext";
import { createStep } from "@component/assets/SmallCalculator/SmallCalculatorStep";
import { Config } from "@config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	FormCity,
	FormEmail,
	FormInput,
	FormPhone,
	FormSelect,
	FormTextArea,
	ProgressButton,
	type ProgressButtonState,
	Stack,
	Typography,
} from "bm-ui-kit";
import type { FC } from "react";
import { Card } from "react-bootstrap";
import { PRODUCT_TYPES } from "../data";
import type { StepValues } from "../type";

interface Props {
	isSubmitted: boolean;
	disabled?: boolean;
}

export const LeadForm = createStep<StepValues["lead-form"], FC<Props>>(
	({ disabled, isSubmitted: submittedLead }: Props) => {
		const { isLoading } = useSmallCalculator();

		let buttonState: ProgressButtonState = isLoading ? "loading" : undefined;
		if (submittedLead) {
			buttonState = "done";
		}

		return (
			<>
				<Card.Body>
					<Typography as="div" variant="h1" className="mb-4 mt-auto">
						Ingyenes Tanácsadás
					</Typography>
					<Stack direction="horizontal" gap={2}>
						<FormInput
							placeholder="Vezetéknév"
							name="lastName"
							prepend={<FontAwesomeIcon icon={faUser} />}
							validate={validLastName}
							disabled={disabled}
							required
						/>
						<FormInput
							placeholder="Keresztnév"
							name="firstName"
							prepend={<FontAwesomeIcon icon={faUser} />}
							validate={validFirstName}
							disabled={disabled}
							required
						/>
					</Stack>
					<FormEmail
						placeholder="Email cím"
						name="email"
						prepend={<FontAwesomeIcon icon={faEnvelope} />}
						disabled={disabled}
						required
					/>
					<FormPhone
						placeholder="Telefonszám"
						name="phone"
						autoComplete="tel"
						prepend={<FontAwesomeIcon icon={faPhone} />}
						disabled={disabled}
						required
					/>
					<FormCity
						placeholder="Lakhely"
						name="cityName"
						autoComplete="address-level2"
						prepend={<FontAwesomeIcon icon={faMapPin} />}
						disabled={disabled}
						required
					/>
					<FormSelect
						placeholder="Miről szeretnél többet megtudni?"
						name="productType"
						options={PRODUCT_TYPES}
						prepend={<FontAwesomeIcon icon={faBuilding} />}
						disabled={disabled}
						required
					/>
					<FormTextArea
						placeholder="Kérdés, megjegyzés"
						name="question"
						autoComplete="off"
						prepend={<FontAwesomeIcon icon={faComments} />}
						rows={3}
						maxLength={500}
						disabled={disabled}
					/>
					<div className="text-center fs-xs pt-2 mt-auto">
						A lenti gomb megnyomásával elfogadom az{" "}
						<a
							className="text-reset text-underline"
							href={Config.getBankmonitorUrl("/adatvedelem/")}
							// biome-ignore lint/a11y/noBlankTarget: in-page link
							target="_blank"
						>
							adatvédelmi tájékoztatóban
						</a>{" "}
						foglaltakat.
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="submit"
						state={buttonState}
						data-testid="button-submit"
						className="font-weight-bold"
						doneProps={{
							children: "Sikeresen beküldve!",
							icon: <FontAwesomeIcon icon={faCircleCheck} />,
						}}
						block
					>
						Elküldöm
					</ProgressButton>
				</Card.Footer>
			</>
		);
	},
);
